const PricelistMixin = (pricelistKey) => {
  return{
    data(){
      return{
        activeCategories: [],
        activeDiscounts: [],
        addedDiscount: 0,
        emptyPricelist: {
          title: '',
          data:{
            category: {
            }
          },
          pricelist_data:{
            category:{

            }
          }
        }
      }
    },

    computed:{
      gratisDiscount(){
        return this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'gratis'})[0].id;
      },

      defaultDiscount(){
        return this.$store.state.receivedData.discounts.list.filter((discount) => {return discount.kind == 'regular'})[0].id;
      }
    },

    methods: {
      recalculatePrice(isDefault, categoryID, value){
        if(isDefault){
          let key = null;
          for(key in this.$store.state.selectedObject[pricelistKey].category[categoryID]){
            let discountObject = this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.id == key})[0];
            if(discountObject !== undefined){
              let calculatedValue = value - (value * (discountObject.discount)/100);
              this.$store.state.selectedObject[pricelistKey].category[categoryID][key] = parseFloat(calculatedValue)
            }
          }
        }
      },

      setDefaultArrays(){
        if(!this.activeDiscounts.includes(this.defaultDiscount));
        this.activeCategories = [1]
        this.activeDiscounts = [parseInt(this.defaultDiscount), parseInt(this.gratisDiscount)]
      },

      createEmptyPricelist(item){
        if(item !== undefined) this.emptyPricelist = JSON.parse(JSON.stringify(item));
        for(let i = 0; i < 5; i++){
          let object = {};
          this.$store.state.receivedData.discounts.list.forEach((discount) =>{
            object[discount.id] = '';
          });
          if(this.emptyPricelist[pricelistKey].category !== undefined) this.emptyPricelist[pricelistKey].category[i] = object;
        }
      },

      clearEmptyPrices(){
        let categoryKey = null;
        let discountKey = null;
        for(categoryKey in this.$store.state.selectedObject[pricelistKey].category){
          if(!this.activeCategories.includes(parseInt(categoryKey))){
            delete this.$store.state.selectedObject[pricelistKey].category[categoryKey]
          } else{
            for(discountKey in this.$store.state.selectedObject[pricelistKey].category[categoryKey]){
              if(!this.activeDiscounts.includes(parseInt(discountKey))){
                delete this.$store.state.selectedObject[pricelistKey].category[categoryKey][discountKey]
              }
            }
          }
        }
      },

      extendPricelist(item){
        let categoryKey = null;
        let discountKey = null;
        this.createEmptyPricelist(item);
        for(categoryKey in this.emptyPricelist[pricelistKey].category){
          for(discountKey in this.emptyPricelist[pricelistKey].category[categoryKey]){
            if(item[pricelistKey].category.hasOwnProperty(categoryKey) && item[pricelistKey].category[categoryKey].hasOwnProperty(discountKey)){
              if(!this.activeCategories.includes(parseInt(categoryKey))) this.activeCategories.push(parseInt(categoryKey));
              if(!this.activeDiscounts.includes(parseInt(discountKey))) this.activeDiscounts.push(parseInt(discountKey));
              this.emptyPricelist[pricelistKey].category[categoryKey][discountKey] = item[pricelistKey].category[categoryKey][discountKey];
            }
          }
        }
        this.$store.state.selectedObject = Object.assign(this.$store.state.selectedObject, this.emptyPricelist);
      },

      validate(){
        this.requiredFields = ['title'];
        this.objectsToValidate = [this.$store.state.selectedObject];
        this.formSubmitted();
        if(this.passed){
          this.clearEmptyPrices();
          this.createOrUpdate();
        }
      },

      categoryOrDiscountChanged(){
        if(this.$store.state.selectedObject[pricelistKey] !== undefined){
          this.clearEmptyPrices();
          this.extendPricelist(this.$store.state.selectedObject);
        }
        if(this.emptyPricelist[pricelistKey].category !== undefined){
          this.activeCategories.forEach((categoryID) =>{
            this.activeDiscounts.forEach((discountID) =>{
              let isDefault = this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.id == discountID})[0];
              if(isDefault !== undefined && this.$store.state.selectedObject[pricelistKey] !== undefined && isDefault.kind == 'regular' && this.activeCategories.indexOf(categoryID) > -1 && this.$store.state.selectedObject[pricelistKey].category[categoryID][isDefault.id] != ''){
                //this.recalculatePrice(true, categoryID, this.$store.state.selectedObject[pricelistKey].category[categoryID][isDefault.id])
              }
            })
          })
        }
      }
    },

    watch:{
      activeDiscounts(){
        this.categoryOrDiscountChanged();
      },

      activeCategories(){
        this.categoryOrDiscountChanged();
      },

      editPricelist(value){
        if(value) this.categoryOrDiscountChanged();
        else{
          this.setDefaultArrays();
        }
      },

      editCreateDialogVisible(value){
        if(value) this.categoryOrDiscountChanged();
        else{
          this.setDefaultArrays();
        }
      },

      isPageLoaded(value){
        if(value) this.setDefaultArrays();
      }
    }
  }
}
export default PricelistMixin;



// WEBPACK FOOTER //
// ./src/mixins/pricelist-mixin.js